import SearchForm from './searchForm/index.vue'
import Vue from 'vue'
export default {
    install(){
        Vue.component("SearchForm", SearchForm)
    }
}



// WEBPACK FOOTER //
// ./src/components/index.js